import { render, staticRenderFns } from "./DuplicateReport.vue?vue&type=template&id=618cc518&scoped=true&"
import script from "./DuplicateReport.vue?vue&type=script&lang=js&"
export * from "./DuplicateReport.vue?vue&type=script&lang=js&"
import style0 from "./DuplicateReport.vue?vue&type=style&index=0&id=618cc518&scoped=true&lang=scss&"
import style1 from "./DuplicateReport.vue?vue&type=style&index=1&id=618cc518&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "618cc518",
  null
  
)

export default component.exports